export default "__VITE_ASSET__Zuqa2aO3__"